import React, { useState, useEffect, useCallback, useContext } from 'react';
import Modal from 'react-modal';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';
import classes from './Table.module.css';
import departments from '../Common/departmentDropDown/Departments';
import authContext from '../../../AuthContext/authContext';
const base_url = process.env.REACT_APP_BASE_URL;


const ExportFilterModal = ({ isOpen, onClose, onExport, locations, title, apiUrl, companyId, locationId }) => {
  const ctx = useContext(authContext);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
    locationId: '',
    department: '',
    employeeName: ''
  });

  // console.log(filters,"filters");
  // Reset form when modal is closed
  useEffect(() => {
    if (!isOpen) {
      setSelectedEmployee(null);
      setFilters({
        startDate: null,
        endDate: null,
        locationId: '',
        department: '',
        employeeName: ''
      });
    }
  }, [isOpen]);

  // Using imported departments array directly

  const loadEmployeeOptions = useCallback(async (inputValue) => {
    if (!inputValue.trim()) {
      return [];
    }
    console.log(filters,"filters");
    try {
      const response = await axios.get(
        `${base_url}/visitor/search/employeeNames/${companyId}/${filters.locationId || null}/${inputValue}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ctx.token}`
          }
        }
      );
      return (response.data.data || []).map(emp => ({
        value: emp._id,
        label: emp.name + (emp.location ? " - " + emp.location : "")
      }));
    } catch (error) {
      console.error('Error fetching employee suggestions:', error);
      return [];
    }
  }, [companyId, filters.locationId, ctx.token,filters ]);

  const handleEmployeeChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
    setFilters(prev => ({
      ...prev,
      employeeName: selectedOption ? selectedOption.label : ''
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };



  const handleDateChange = (date, name) => {
    setFilters(prev => ({
      ...prev,
      [name]: date
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const exportParams = {
      ...filters,
      startDate: filters.startDate ? filters.startDate.toISOString().split('T')[0] : '',
      endDate: filters.endDate ? filters.endDate.toISOString().split('T')[0] : '',
      employeeName: filters.employeeName || '',
      department: filters.department || '',
      locationId: filters.locationId || ''
    };
    
    // Remove empty filters
    Object.keys(exportParams).forEach(key => {
      if (exportParams[key] === '' || exportParams[key] === null || exportParams[key] === undefined) {
        delete exportParams[key];
      }
    });
    
    onExport(exportParams);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={classes.exportModal}
      overlayClassName={classes.exportOverlay}
    >
      <div className={classes.exportHeader}>
        <h3>{title}</h3>
        <button onClick={onClose} className={classes.closeButton}>&times;</button>
      </div>
      
      <form onSubmit={handleSubmit} className={classes.exportForm}>
        <div className={classes.formGroup}>
          <label>Location</label>
          <select 
            name="locationId" 
            value={filters.locationId}
            onChange={handleInputChange}
            className={classes.selectInput}
          >
            <option value="">All Locations</option>
            {locations && locations.map(loc => (
              <option key={loc._id} value={loc._id}>
                {loc.location}
              </option>
            ))}
          </select>
        </div>
        <div className={classes.formGroup}>
          <label>Employee Name</label>
          <AsyncSelect
            className={classes.selectInput}
            cacheOptions
            placeholder="Search employee..."
            value={selectedEmployee}
            onChange={handleEmployeeChange}
            loadOptions={loadEmployeeOptions}
            isClearable
            styles={{
              container: (base) => ({
                ...base,
                width: '100%',
                minHeight: '38px',
              }),
              control: (base) => ({
                ...base,
                minHeight: '38px',
                height: '38px',
                border: '1px solid #ced4da',
                '&:hover': {
                  borderColor: '#80bdff',
                }
              }),
              valueContainer: (base) => ({
                ...base,
                padding: '0 8px',
              }),
              input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
              }),
              dropdownIndicator: (base) => ({
                ...base,
                padding: '4px 8px',
              }),
              clearIndicator: (base) => ({
                ...base,
                padding: '4px 8px',
              }),
              menu: (base) => ({
                ...base,
                zIndex: 1000,
                marginTop: '4px',
              }),
            }}
          />
        </div>

        <div className={classes.formGroup}>
          <label>Start Date</label>
          <DatePicker
            selected={filters.startDate}
            onChange={(date) => handleDateChange(date, 'startDate')}
            selectsStart
            startDate={filters.startDate}
            endDate={filters.endDate}
            className={classes.dateInput}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select start date"
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={10}
            showMonthDropdown
            dropdownMode="select"
          />
        </div>

        <div className={classes.formGroup}>
          <label>End Date</label>
          <DatePicker
            selected={filters.endDate}
            onChange={(date) => handleDateChange(date, 'endDate')}
            selectsEnd
            startDate={filters.startDate}
            endDate={filters.endDate}
            minDate={filters.startDate}
            className={classes.dateInput}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select end date"
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={10}
            showMonthDropdown
            dropdownMode="select"
          />
        </div>

        <div className={classes.formGroup}>
          <label>Department</label>
          <select 
            name="department" 
            value={filters.department}
            onChange={handleInputChange}
            className={classes.selectInput}
          >
            <option value="">All Departments</option>
            {departments.map((dept, index) => (
              <option key={`dept-${index}`} value={dept}>
                {dept}
              </option>
            ))}
          </select>
        </div>

     

        <div className={classes.buttonGroup}>
          <button type="button" onClick={onClose} className={classes.cancelButton}>
            Cancel
          </button>
          <button type="submit" className={classes.exportButton}>
            Export CSV
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ExportFilterModal;
